if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      document.body.classList.remove('dimmer');
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          
          this.preventVariantURLSwitching();
         
          super.show(opener);
          this.updateImageSizes();
          swymAttachEvents(this.productElement);
          triggerKlarnaAndJudgeMe();
          
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      product.querySelector('.product__column-sticky').classList.add = "hidden";

      // product.querySelector('.product__media-wrapper').innerHTML = 'Load images';
      const productImageSize = product.querySelectorAll('.product__media img.image-magnify-lightbox');
      const collectNeededImages = document.querySelectorAll('.quick-add-modal[open] ul li .product__media img');

      var imagesList = [];
      collectNeededImages.forEach(img => {
        var imgSrc = img.getAttribute('src');
        var alt = img.getAttribute('alt');
        if(imagesList.indexOf('<li><img src="'+imgSrc+'"></li>') == -1) {
          imagesList.push('<li><img src="'+imgSrc+'" alt="'+alt+'"></li>');
        }
      });
      
      var isMobile = Math.min(window.screen.width, window.screen.height) < 768 || navigator.userAgent.indexOf("Mobi") > -1;
      if(isMobile) {
        var wrapper= document.createElement('div');
        wrapper.innerHTML= '<div><ul class="mobile-slider">'+imagesList.join("")+'</ul><div class="mobilePagingInfo"></div></div>';
        var div= wrapper.firstChild;
        // Get a reference to the element, before we want to insert the element
        var sp2 = document.querySelector('.quick-add-modal[open]  .product__description');
        // Get a reference to the parent element
        var parentDiv = sp2.parentNode;
        parentDiv.insertBefore(div, sp2);
        initMobileQuickviewSlider();
        
      } else {
        product.querySelector('.product__media-wrapper').innerHTML += '<ul>'+imagesList.join("")+'</ul>';
      }
      

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

     
      // let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      // if (product.classList.contains('product--medium')) {
      //   mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      // } else if (product.classList.contains('product--small')) {
      //   mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      // }
      
      // product__media media media--transparent
      // mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
      //<ul>
    }

    
  });
}

window.swymCallbackFn = function(swat){
    window.swymAttachEvents = function(prod){
      //
      var variantId = $(".quick-add-modal[open] [name='id']").val();
      var productId = $(".quick-add-modal[open] .product__info-container").attr('data-product-id');
      var productURL = $(".quick-add-modal[open] .product__info-container").attr('data-product-url');
      document.querySelector('.quick-add-modal[open] .product-form__buttons').innerHTML+=`<div class="swym-button-bar swym-wishlist-button-bar">
            <div class="swym-btn-container" data-position="default">
             <button aria-label="Add to Wishlist" id="swym-quick-view" data-with-epi="true" class="swym-button swym-add-to-wishlist " data-swaction="addToWishlist"  data-product-id="${productId}" data-variant-id="${variantId}" data-product-url="${productURL}"><span class="swym-wishlist-cta"></span></button> 
            </div>
          </div> `;
      setTimeout(function(){
        swat.initializeActionButtons(".quick-add-modal[open] .product-form");
      },2000)
      
    }
}

if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
function getVariantPrice() {
  var productJson = $(".quick-add-modal[open] .product_json").html();
  productJson = JSON.parse(productJson);
  var variants = productJson.variants;
  var variantId = $("quick-add-modal[open]  [name='id']").val();
  var price = 0;
  variants.forEach((element) => {
    if(element.id == variantId) {
       price = element.price;
    }
  });
  return price;
}
window.triggerKlarnaAndJudgeMe = function() {
  $('.quick-add-modal[open] klarna-placement').attr("data-locale",'en-IE');
  $('.quick-add-modal[open] klarna-placement').attr("data-purchase-amount",getVariantPrice());
  Klarna.OnsiteMessaging.refresh();
}

window.initMobileQuickviewSlider = function() {

  var $status = $('.quick-add-modal[open] .mobilePagingInfo');
  var $slickElement = $('.quick-add-modal[open] .mobile-slider');
  
  $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    // no dots -> no slides
    if(!slick.$dots){
      return;
    }
    
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    // use dots to get some count information
    $status.text(i + '/' + (slick.$dots[0].children.length));
  });
  
  $slickElement.slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    centerMode: true,
    responsive: [
        {
            breakpoint: 567,
            settings: {
                slidesToScroll: 1,
                slidesToShow: 1
            }
        }
    ]
    
  });
  initScrollFixedButton();
}

window.initScrollFixedButton = function() {
  const scrollable = document.querySelectorAll(".quick-add-modal[open] .quick-add-modal__content")[0];
  scrollable.addEventListener("scroll", e => {
    // This shows how far down in the element we've scrolled.
    if(scrollable.scrollTop > 100) {
        document.querySelector(".quick-add-modal[open] .quick-add-modal__content-info").classList.add("sticky-bottom");
    } else {
        document.querySelector(".quick-add-modal[open] .quick-add-modal__content-info").classList.remove("sticky-bottom");
    }
  })
}